var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isValueSelected)?_c(_vm.tag,{tag:"component",attrs:{"value":_vm.value}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }